import React from "react";
import PropTypes from "prop-types";
import { Dialog, Button } from "@gonoodle/gn-universe-ui";
import { useMutation, useQueryClient } from "react-query";

import api from "../api";
import { QUERY_KEYS } from "../constants";
import { useLogEvent } from "../contexts/Analytics";

function UserSelfIdModal({ isOpen, onClose, analyticsProps }) {
  const client = api();
  const queryClient = useQueryClient();

  const { mutate: updateUser, isSuccess: updateUserSucceeded } = useMutation(
    (selectedUserType) => client.updateUser({ userType: selectedUserType }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEYS.USER);
      },
      retry: 3,
    },
  );

  useLogEvent({
    event: "User Identification Modal Viewed",
    properties: analyticsProps,
    options: {
      enabled: !!isOpen,
    },
  });

  useLogEvent({
    event: "User Identified",
    properties: analyticsProps,
    options: {
      enabled: !!updateUserSucceeded,
    },
  });

  return (
    <Dialog.Root isOpen={isOpen} isDismissable={true} onClose={onClose}>
      <Dialog.Content className="inline-block w-full md:w-screen-xs p-md my-8 align-middle bg-white rounded-lg text-center overflow-hidden transform transition-all">
        <div className="flex flex-col space-y-md">
          <Dialog.Title className="gn-headline-sm">
            Quick question!
          </Dialog.Title>
          <p className="gn-text">
            How are you using GoNoodle? Your answer will help us give you the
            best experience.
          </p>
          <div className="flex flex-col space-y-sm">
            <Button
              variant="dark-outline"
              size="md"
              onPress={() => {
                updateUser("unregistered_teacher");
                onClose();
              }}
            >
              I&apos;m using GoNoodle as an educator
            </Button>
            <Button
              variant="dark-outline"
              size="md"
              onPress={() => {
                updateUser("unregistered_family");
                onClose();
              }}
            >
              I&apos;m using GoNoodle for my family
            </Button>
          </div>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
}

UserSelfIdModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  analyticsProps: PropTypes.shape({
    contentType: PropTypes.string,
    id: PropTypes.string,
    title: PropTypes.string,
    sourcePage: PropTypes.string,
    sourcePageType: PropTypes.string,
    sourceElement: PropTypes.string,
    sourceName: PropTypes.string,
  }).isRequired,
};

UserSelfIdModal.defaultProps = {
  isOpen: false,
  onClose: () => {},
};

export default UserSelfIdModal;
